import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./userNotification.module.css";

const UserNotification = ({
  completeData,
  incompleteData,
  isVisible,
  duplicateUsers,
  setUserAdded,
  onClose,
  className = "",
}) => {
  const navigate = useNavigate();

  const onXCircleIconClick = useCallback(() => {
    // navigate("/user-management");
    setUserAdded(false);
  }, [navigate]);

  // if(!isVisible) return null
  return (
    <div className={[styles.frameParent, className].join(" ")}>
      <div className={styles.containerNotifi}>
        <div className={styles.httpslottiefilescomanimatParent}>
          <div className={styles.httpslottiefilescontent}>
            <div className={styles.httpslottiefilescontent1}>
              {completeData}
              <img
                className={styles.plusCircleIconHeading}
                alt=""
                src="/check-circle.svg"
              />
            </div>
            <div className={styles.plusCircleIcontext}>
              Users added successfully
            </div>
          </div>
        </div>
        <button
          className={styles.userAddedSuccessfullyBtn}
          onClick={() => {
            onXCircleIconClick();
          }}
        >
          Return to User management
        </button>
      </div>
    </div>
  );
};

export default UserNotification;
